import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { post } from 'utils/http'

export const useAgencyCreate = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const createAgency = async (values: any) => post(`/management/customers/${customerId}/master`, values)

  return useMutation({
    mutationFn: createAgency,
    onSuccess: async () => {
      addNotification('Agency plan created successfully')

      await queryClient.invalidateQueries({ queryKey: ['customer', String(customerId)] })
    },
  })
}
